import React from 'react';
import './Temperature.Widget.css';

export default function TemperatureWidget({ values, size = 32 }) {
  const unit = '°c';
  const [currTemperature = '-', max = '-', min = '-'] = values;
  const parsedValue = parseInt(currTemperature, 10);
  const colors = React.useMemo(() => {
    if (parsedValue > 25) {
      return '#dc2626'; // hot
    } if (parsedValue <= 24 && parsedValue >= 1) {
      return '#fb923c'; // warm
    } if (parsedValue <= 0) {
      return '#3b82f6'; // cold
    }
    return 'gray'; // нет данных
  }, [parsedValue]);

  return (
    <>
      <div className="temperature-widget-current">
        <TemperatureIcon size={size} color={colors} />
        <span className="temperature-widget-current-value">
          <p>{`${currTemperature}`}</p>
          <p>{unit}</p>
        </span>
      </div>
      <div className="temperature-widget-min-max">
        <p>{`Макc.: ${max}${unit}`}</p>
        <p>{`Мин.: ${min}${unit}`}</p>
      </div>
    </>
  );
}

function TemperatureIcon({ size, color }) {
  return (
    <div className="temperature-widget-icon">
      <svg width={size} height={size} viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.5 0C7.67157 0 7 0.671573 7 1.5V9.33682C5.81753 9.89855 5 11.1038 5 12.5C5 14.433 6.567 16 8.5 16C10.433 16 12 14.433 12 12.5C12 11.1038 11.1825 9.89855 10 9.33682V1.5C10 0.671573 9.32843 0 8.5 0ZM2 5.5C2 5.22386 2.22386 5 2.5 5L5.5 5C5.77614 5 6 5.22386 6 5.5C6 5.77614 5.77614 6 5.5 6L2.5 6C2.22386 6 2 5.77614 2 5.5ZM2.5 1C2.22386 1 2 1.22386 2 1.5C2 1.77614 2.22386 2 2.5 2L5.5 2C5.77614 2 6 1.77614 6 1.5C6 1.22386 5.77614 1 5.5 1L2.5 1ZM4 3.5C4 3.22386 4.22386 3 4.5 3H5.5C5.77614 3 6 3.22386 6 3.5C6 3.77614 5.77614 4 5.5 4H4.5C4.22386 4 4 3.77614 4 3.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H5.5C5.77614 8 6 7.77614 6 7.5C6 7.22386 5.77614 7 5.5 7L4.5 7Z" />
      </svg>
    </div>
  );
}
